const ExpoLogistic = () => {
    return (
        <div>
          <div className="">
            <img src="/logisticsBanner/banner-8.jpg" width="100%"/>
          </div>
          <div className="flex flex-col justify-center items-center mb-[1.5rem]">
            <hr className="w-[52rem]"/>
            <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
             
              <div className="flex flex-col justify-center">
                <h1 className="font-bold text-3xl text-[#373737]">
                    Expo Logistics 
                </h1>
                <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                    TCS Expo Logistics arm provides supply chain management services with plans, implementation, and control of efficient forward and reverse flow and storage of goods, services, and related information between points of origin and point of exhibition in order to meet complex and strictly time-sensitive needs of customers.
                </p>
                <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                    TCS teams with exceptional hands-on experience, the largest logistics network and services ensure secure and reliable solutions for planning, shipping, handling, storage and transportation of equipment and installations across the country.
                </p>
              </div>
              <div className="flex-1 flex flex-col justify-center items-center">
                <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
              </div>
            </div>
          
          </div>
        </div>
    
    )
};
export default ExpoLogistic;